import styled from 'styled-components'

const CopyrightContentView = styled.div`
  margin: 0 auto;
  max-width: 1024px;
  min-width: 320px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.shell.footer.copyright.color};
  font-size: ${props => props.theme.shell.footer.copyright.fontSize};
  line-height: ${props => props.theme.shell.footer.copyright.lineHeight};
  padding: 24px 20px;

  > hr {
    background-color: ${props => props.theme.shell.footer.copyright.separatorColor};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    gap: 12px;
    padding: 36px 40px;

    > hr {
      display: none;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.landscape}px) {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
`

export default CopyrightContentView
